import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { ExternalLink } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0A1F2E] text-slate-300 mt-16" data-testid="main-footer">
      <div className="container-app py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-10">

          {/* Brand */}
          <div className="md:col-span-1">
            <Logo size="md" dark />
            <p className="mt-4 text-sm text-slate-400 leading-relaxed font-light">
              Vérifiez. Comprenez. Décidez sereinement.
            </p>
            <p className="mt-3 text-xs text-slate-600 leading-relaxed">
              Outil d'aide à la décision. Ne constitue pas un avis juridique.
            </p>
          </div>

          {/* Outil */}
          <div>
            <h4 className="text-xs font-medium uppercase tracking-widest text-slate-500 mb-4"
                style={{ fontFamily: "'DM Sans', sans-serif" }}>
              Outil
            </h4>
            <ul className="space-y-2.5">
              {[
                ["/",                  "Analyser un site"],
                ["/comment-ca-marche", "Comment ça marche"],
                ["/signaux",           "Signaux analysés"],
                ["/blog",              "Blog"],
              ].map(([to, label]) => (
                <li key={to}>
                  <Link to={to} className="text-sm text-slate-400 hover:text-white transition-colors font-light">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Ressources */}
          <div>
            <h4 className="text-xs font-medium uppercase tracking-widest text-slate-500 mb-4"
                style={{ fontFamily: "'DM Sans', sans-serif" }}>
              Ressources officielles
            </h4>
            <ul className="space-y-2.5">
              {[
                ["https://signal.conso.gouv.fr",                                 "SignalConso"],
                ["https://www.service-public.fr/particuliers/vosdroits/F35949",  "Service-Public"],
                ["https://www.cnil.fr",                                          "CNIL"],
                ["https://www.cybermalveillance.gouv.fr",                        "Cybermalveillance.gouv.fr"],
              ].map(([href, label]) => (
                <li key={href}>
                  <a
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-slate-400 hover:text-white transition-colors inline-flex items-center gap-1.5 font-light"
                  >
                    {label}
                    <ExternalLink className="w-3 h-3" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Légal */}
          <div>
            <h4 className="text-xs font-medium uppercase tracking-widest text-slate-500 mb-4"
                style={{ fontFamily: "'DM Sans', sans-serif" }}>
              Légal
            </h4>
            <ul className="space-y-2.5">
              {[
                ["/a-propos",                      "À propos"],
                ["/contact",                       "Contact"],
                ["/mentions-legales",              "Mentions légales"],
                ["/politique-de-confidentialite",  "Politique de confidentialité"],
                ["/en-cas-de-doute",               "En cas de doute"],
              ].map(([to, label]) => (
                <li key={to}>
                  <Link to={to} className="text-sm text-slate-400 hover:text-white transition-colors font-light">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-xs text-slate-600">
            © {new Date().getFullYear()} Fiable ou Pas — fiableoupas.com — Tous droits réservés
          </p>
          <p className="text-xs text-slate-700">
            Outil informatif uniquement. Les résultats ne constituent pas une garantie.
          </p>
        </div>
      </div>
    </footer>
  );
}
